import {
  Channel,
  BaseSavedSearch,
  HolidayRentalSavedSearchDto,
} from "../model/model";

export class HolidayRentalMapper {
  static dtoToModel({
    id,
    name,
    web,
    mail,
  }: HolidayRentalSavedSearchDto): BaseSavedSearch {
    return {
      id,
      name,
      notifications: { [Channel.WEB]: web, [Channel.EMAIL]: mail },
    };
  }

  static modelToDto({
    id,
    name,
    notifications,
  }: BaseSavedSearch): HolidayRentalSavedSearchDto {
    return {
      id,
      name,
      web: Boolean(notifications[Channel.WEB]),
      mail: Boolean(notifications[Channel.EMAIL]),
    };
  }
}
